/* eslint-disable import/prefer-default-export */

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-25 18:39:55
 * @LastEditTime: 2022-03-07 15:34:18
 * @LastEditors: wangshengqiang
 * @Description: 接口服务
 */
import request from '@/utils/request';
export * from './JDservice'; // 查询经代页面配置

export function queryGoodsTemplateConfig(data) {
  return request('/v1/insure/queryGoodsTemplateConfig', {
    method: 'POST',
    data
  });
} // 查询商品详情

export function queryGoodsDetail(data) {
  return request('/goods/v1/goods/queryGoodsDetail', {
    method: 'POST',
    data
  });
} // 根据计划查询健康告知

export const queryNoticeQuestionListDetail = data => {
  return request('/v1/goods/notice/queryNoticeQuestionListDetail', {
    method: 'POST',
    data
  });
};
/**
 * 手机扫码预览下获取所有页面配置信息
 * @param {Object} params
 * key: 'string',
 */

export function getAllPreviewPageConfig(insureConfig) {
  return request(`/v1/insure/previewGoodsTemplateConfig?insureConfigId=${insureConfig}`, {
    method: 'POST'
  });
} // 查询支付状态

export function queryPayStatus(data) {
  return request('/v1/insure/queryPayStatus', {
    method: 'POST',
    data
  });
} // 跳转人脸识别

export function linkFaceAuthModal(data) {
  const opts = {
    method: 'POST',
    data
  };

  if (window.sessionStorage.getItem('onlineToken')) {
    opts.headers = {
      onlineToken: window.sessionStorage.getItem('onlineToken')
    };
  }

  return request('/app/faceOcr/faceAuth', opts);
}
export function queryFaceAuthResult(data) {
  const opts = {
    method: 'POST',
    data
  };

  if (window.sessionStorage.getItem('onlineToken')) {
    opts.headers = {
      onlineToken: window.sessionStorage.getItem('onlineToken')
    };
  }

  return request('/app/faceOcr/queryFaceAuthResult', opts);
}
export function queryAuthList({
  encryptOrderNo,
  channelCode
}) {
  return request(`/v1/authentication/queryAuthList?encryptOrderNo=${encryptOrderNo}&channelCode=${channelCode}`, {
    method: 'POST'
  });
}
export function updateAuthStatus(data) {
  return request('/v1/authentication/updateAuthStatus', {
    method: 'POST',
    data
  });
}